import type { SVGProps } from "react";
import * as React from "react";

const SvgAmexBadge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 35 24"
    {...props}
  >
    <rect
      width={34}
      height={23}
      x={0.5}
      y={0.5}
      fill="#1F72CD"
      stroke="#D9D9D9"
      rx={3.5}
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M6.681 8.5 3.5 15.747h3.808l.472-1.156h1.08l.472 1.156h4.191v-.882l.374.882h2.168l.374-.9v.9h8.718l1.06-1.126.992 1.126 4.478.01-3.191-3.613 3.19-3.644H27.28l-1.032 1.105-.962-1.105h-9.483l-.815 1.87-.833-1.87h-3.8v.852L9.93 8.5zM19.7 9.529h5.006l1.532 1.703 1.58-1.703h1.531l-2.326 2.614 2.326 2.583h-1.6l-1.531-1.722-1.589 1.722h-4.929zm1.237 2.026v-.95h3.123l1.363 1.518L24 13.649h-3.063v-1.036h2.73v-1.058zM7.418 9.529h1.856l2.11 4.914V9.53h2.034l1.63 3.523L16.55 9.53h2.023v5.2h-1.231l-.01-4.075-1.795 4.075h-1.102l-1.805-4.075v4.075h-2.532l-.48-1.166H7.023l-.479 1.165H5.187zm.048 2.957.855-2.077.854 2.077z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAmexBadge;
